import { Component } from '@angular/core';
import { FieldWrapper } from '@ngx-formly/core';

@Component({
    selector: 'bp2s-formly-expansion-panel',
    templateUrl: './formly-expansion-panel.component.html',
    styleUrls: ['./formly-expansion-panel.component.scss'],
    standalone: false
})
export class FormlyExpansionPanelComponent extends FieldWrapper {}
